import { TrackingConfiguration, TrackingOwnership, TrackingPersonalization, TrackingUser } from './tracking-types';

export const emptyPersonalization: TrackingPersonalization = {
	status: false,
	moduleId: undefined,
	placeholderId: undefined,
	contentId: undefined,
	activityId: undefined,
	personalizable: undefined,
	activityName: undefined,
	experienceId: undefined,
	experienceName: undefined,
	offerId: undefined,
	offerName: undefined,
};

export const emptyPriceConfiguration: TrackingConfiguration = {
	PriceType: 'price',
	PriceTypeParameter: undefined,
	PriceRateCurrency: undefined,
	PriceRateBasic: undefined,
	PriceRateAdditional: undefined,
	PriceRateTotal: undefined,
	PriceRateType: undefined,
	PriceTotalCurrency: undefined,
	PriceTotalBasic: undefined,
	PriceTotalAdditional: undefined,
	PriceTotalTotal: undefined,
};

export const emptyVehiclePreconfiguration: TrackingConfiguration = {
	SalesgroupId: undefined,
	SalesgroupName: undefined,
	EquipmentlineName: undefined,
	CarlineId: undefined,
	CarlineName: undefined,
};

export const emptyLatLongZip: TrackingUser = {
	locationLatitude: undefined,
	locationLongitude: undefined,
	locationZIP: undefined,
};

export const emptyConfig = { ...emptyPriceConfiguration, ...emptyVehiclePreconfiguration };

export const emptyOwnership: TrackingOwnership = {
	vehicle: '',
};
